import { SITE } from '@/app/constants';
import type { ToolTaskType } from '@/app/types';

const BASE_URL =
  SITE === 'global'
    ? 'https://image01.cf.vidu.studio/vidu/media-asset'
    : 'https://image01-aliyun.vidu.zone/vidu/media-asset';

type ExampleMediaPreviewBadgeKey =
  | 'tools.example'
  | 'tools.before'
  | 'tools.after'
  | 'tools.original'
  | 'tools.upscaleBadge';

export type ExampleMediaToolType = ToolTaskType | 'video2extend' | 'video_edit' | 'image_edit';

interface ExampleMediaPreviewConfig {
  imageUrl?: string;
  videoUrl?: string;
  imageLayout?: 'single' | 'splitDuplicate';

  badgeKeys?: readonly ExampleMediaPreviewBadgeKey[];
  poster?: string;
}

export const EXAMPLE_MEDIA_PREVIEW_CONFIG: Partial<Record<ExampleMediaToolType, ExampleMediaPreviewConfig>> = {
  face_swap: {
    videoUrl: `${BASE_URL}/face_swap-8e7dd778.mp4`,
    badgeKeys: ['tools.example'],
  },
  image_edit: {
    imageUrl: `${BASE_URL}/edit-image-71df4940.webp`,
    badgeKeys: ['tools.before', 'tools.after'],
  },
  one_click: {
    videoUrl: `${BASE_URL}/one_click-11f57240.mp4`,

    badgeKeys: ['tools.example'],
  },
  music_video: {
    videoUrl: `${BASE_URL}/onclick-mv-918ae031.mp4`,
    badgeKeys: ['tools.example'],
  },
  lip_sync: {
    videoUrl: `${BASE_URL}/lipsync-b60e485b.mp4`,
    badgeKeys: ['tools.example'],
  },
  offline_avatar: {
    videoUrl: `${BASE_URL}/lipsync-b60e485b.mp4`,
    badgeKeys: ['tools.example'],
  },
  remake: {
    videoUrl: `${BASE_URL}/remake-3be701b4.mp4`,
    badgeKeys: ['tools.before', 'tools.after'],
  },
  upscale: {
    videoUrl: `${BASE_URL}/upscale-36798343.mp4`,
    badgeKeys: ['tools.before', 'tools.after'],
  },
  upscale_image: {
    imageUrl: `${BASE_URL}/upscale-image-c37faa2e.webp`,
    badgeKeys: ['tools.before', 'tools.after'],
  },
  motion_control: {
    videoUrl: `${BASE_URL}/motion-control-example-3d21ac35.mp4`,
    badgeKeys: ['tools.before', 'tools.after'],
  },
  video2extend: {
    videoUrl: `${BASE_URL}/extend-cb101c7b.mp4`,
  },
  video_edit: {
    videoUrl: `${BASE_URL}/edit_video-e467e801.mp4`,
    badgeKeys: ['tools.before', 'tools.after'],
  },
};
